module.exports = __webpack_public_path__ + "static/media/spaceperson.857a9037.svg";